import { useEffect, useState } from "react";
import "./style.scss";
import TextInput from "@builder/components/general/TextInput";
import { ActionType } from "@common/build/types";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";

const Notification = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const dispatch = useAppDispatch();
    const [message, setMessage] = useState<string>(actionStep?.action?.message || "");

    useEffect(() => {
        if (message) {
            const action = { type: ActionType.NOTIFICATION, message };
            const updatedStep = { ...actionStep };
            updatedStep.action = { ...action };
            if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
                dispatch(updateStepperActions({ id: id, item: updatedStep as ActionEditorItem }));
            }
        }
    }, [message, actionStep, dispatch, id]);

    return (
        <div className="notification-wrapper">
            <TextInput title="Notification message" callback={setMessage} value={message} className="actions-tab-input" placeholder="Enter message" />
        </div>
    );
};

export default Notification;
